export interface Category {
  slug: string;
  name: string;
  icon: string;
  description: string;
}

export const categories: Category[] = [
  {
    slug: 'dianying',
    name: '电影',
    icon: 'ri-movie-2-line',
    description: '精选国产高清电影，涵盖动作、喜剧、爱情、悬疑等多种类型，每周更新最新院线大片。',
  },
  {
    slug: 'dianshiju',
    name: '电视剧',
    icon: 'ri-tv-2-line',
    description: '热门国产电视剧全集在线观看，包含古装、现代、都市、谍战等各类题材，追剧必备。',
  },
  {
    slug: 'zongyi',
    name: '综艺',
    icon: 'ri-emotion-laugh-line',
    description: '大型综艺节目高清合集，音乐选秀、真人秀、脱口秀、旅行综艺一网打尽。',
  },
  {
    slug: 'jilupian',
    name: '纪录片',
    icon: 'ri-camera-lens-line',
    description: '高品质国产纪录片，涵盖自然、历史、人文、科技等领域，用镜头讲述中国故事。',
  },
  {
    slug: 'dongman',
    name: '动漫',
    icon: 'ri-ghost-line',
    description: '国产动漫佳作合集，热血、玄幻、搞笑、治愈各类型应有尽有，国漫崛起之作。',
  },
  {
    slug: 'duanju',
    name: '短剧',
    icon: 'ri-smartphone-line',
    description: '精品国产短剧，每集5-15分钟，剧情紧凑节奏快，适合碎片化时间观看。',
  },
  {
    slug: 'tiyu',
    name: '体育',
    icon: 'ri-basketball-line',
    description: '体育赛事精彩集锦与专题节目，足球、篮球、乒乓球、羽毛球等热门赛事全覆盖。',
  },
  {
    slug: 'yinyue',
    name: '音乐',
    icon: 'ri-music-2-line',
    description: '音乐MV、演唱会、音乐节目高清合集，华语乐坛精彩内容尽在此处。',
  },
];